$(document).ready(function() {

   // Changement de langue
   $("#FooterLanguageForm span").click(function(e) {
      $(this).siblings('input[name=locale_code]').val($(this).data("value"));
      $(this).parent().submit();
   });

   // Header transparent sur la home
   $(".transparent_header .header-wrapper").hover(function() {
      $(".transparent_header .announcement-bar").addClass("regular_header");
   }, function() {
      $(".transparent_header .announcement-bar").removeClass("regular_header");
   });

   if ($(window).width() < 768) {
      $("body").removeClass("transparent_header");
   }

   // Menu mobile
   $(".level_1_mobile > li > .menu-drawer__menu-item").click(function(e) {
      var title = $(".level_1_mobile > li > .menu-drawer__menu-item");
      var answers = $(".level_1_mobile > li > div")
      $(this).toggleClass("opened");
      if (answers.length) {
         $(title).not($(this)).removeClass("opened");
         $(title).not($(this)).next(answers).slideUp();
         $(this).next("div").slideToggle();
      }
   });

    // Slider images page charte
   $('.slider_charte .rte').slick({
      slidesToShow: 5,
      infinite: true,
      arrows: true,
       responsive: [
         {
            breakpoint: 1440,
            settings: {
               slidesToShow: 4,
            }
         },
         {
            breakpoint: 1160,
            settings: {
               slidesToShow: 3,
            }
         },
         {
            breakpoint: 820,
            settings: {
               slidesToShow: 2,
            }
         },
         {
            breakpoint: 750,
            settings: {
               slidesToShow: 1,
            }
         }
      ]
   });

    // Slider images page charte
   $('.card_product_cart').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplaySpeed: 3000,
      arrows: false,
      fade: true,
      autoplay: true,
      dots: false
   });

   // Section slider de produit
/*    var products_slider = $(".slider-component-desktop").height();
   console.log(products_slider);
   $('.product_slider').height(products_slider / 6);
 */

   // Page produit

   $("#inci").click(function(e) {
      $("#inci_pop").fadeIn(function () {
         $("#inci_pop .pop_content").fadeIn();
      });
   });

   // Fermeture popin (?)
   $(".close").click(function(e) {
      $(".pop_content").fadeOut();
      $(".pop").fadeOut();
   });


   // Pages FAQ : accordeon
   // Comportement questions FAQ, CGV, Mentions
   $(".accordeon h3").click(function(e) {
      var questions = $(".accordeon h3");
      var answers = $(".accordeon > div");
      $(this).toggleClass("opened");
      if (answers.length) {
         $(questions).not($(this)).removeClass("opened");
         $(questions).not($(this)).next(answers).slideUp();
         $(this).next("div").slideToggle();
      }
   });

      // Popin d'inscription newsletter en homepage
   var PromoCookie = {};
   PromoCookie.cookie = {
      configuration: {
         expires: null, //session cookie
         path: '/',
         domain: window.location.hostname
      },
      name: 'newsletter_home',
      write: function(promo) {
         $.cookie(this.name, promo, this.configuration);
      },
      read: function() {
         return $.cookie(this.name);
      }
   };
   var cookieExists = PromoCookie.cookie.read();

  /*  if(!cookieExists) {
      PromoCookie.cookie.write('newsletter_home');
      var $thisModal = $('#newsletter_popin');
      $thisModal.delay(5000).fadeIn('fast');
   }
   else {
      // Si l'url contient "?customer_posted=true", on doit afficher la popin également
      let searchParams = new URLSearchParams(window.location.search);
      if(searchParams.has('customer_posted')){
         var $thisModal = $('#newsletter_popin');
         $thisModal.fadeIn('fast');
      }
   } */

});